
export type ClientErrorSource = 'error-boundary' | 'window-error' | 'unhandled-rejection';

const ENDPOINT = '/api/client-error';

// ponytail: per-page-load cap is the whole rate-limit story; server-side limiting if abused.
const MAX_REPORTS_PER_LOAD = 5;
let sent = 0;

function describeError(error: unknown): { message: string; stack?: string } {
  if (error instanceof Error) {
    return { message: error.message || error.name, stack: error.stack };
  }
  return { message: String(error) };
}

/** Fire-and-forget crash report to our own server. Never throws. */
export function reportClientError(source: ClientErrorSource, error: unknown): void {
  try {
    if (sent >= MAX_REPORTS_PER_LOAD) return;
    sent += 1;

    const { message, stack } = describeError(error);
    const body = JSON.stringify({ source, message, stack, url: window.location.pathname });

    const beaconOk =
      typeof navigator.sendBeacon === 'function' &&
      navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'application/json' }));
    if (!beaconOk) {
      void fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    // The reporter must never take the page down with it.
  }
}

export function installGlobalErrorReporting(): void {
  window.addEventListener('error', (event) => {
    reportClientError('window-error', event.error ?? event.message);
  });
  window.addEventListener('unhandledrejection', (event) => {
    reportClientError('unhandled-rejection', event.reason);
  });
}
